import axios from "axios";

// 1. Backend Production Base URL
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://expolead.thensgroup.in";
export const API = `${BACKEND_URL.replace(/\/+$/, "")}/api`;

const api = axios.create({
  baseURL: API,
  timeout: 30000, // 30s default timeout
});

api.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("ls_token") ||
    localStorage.getItem("token") ||
    localStorage.getItem("access_token");

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail || "";

    // 401: Token expired or token_version invalidated (password reset elsewhere)
    // 403: Account deactivated, anonymized, or session blocked
    const isAuthRevoked =
      status === 401 ||
      (status === 403 &&
        (detail.includes("deactivated") ||
          detail.includes("closed") ||
          detail.includes("Access revoked")));

    if (isAuthRevoked) {
      localStorage.removeItem("ls_token");
      localStorage.removeItem("token");
      localStorage.removeItem("access_token");
      localStorage.removeItem("ls_user");

      const isHashRouting = window.location.hash.startsWith("#");
      const currentPath = isHashRouting
        ? window.location.hash.replace("#", "")
        : window.location.pathname;

      if (!currentPath.startsWith("/auth") && !currentPath.startsWith("/share")) {
        const redirectUrl = status === 403 ? "/auth/login?blocked=true" : "/auth/login?expired=true";
        if (isHashRouting) {
          window.location.hash = `#${redirectUrl}`;
        } else {
          window.location.assign(redirectUrl);
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;